let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8kPn2")).then(() => parcelRequire('coYId'));